module.exports = "/images/no-img.png?4ae6e5d5093ae2203e370aadf2747c3d";